import { render, staticRenderFns } from "./BulkCuratedUpload.vue?vue&type=template&id=e55d8298&scoped=true&"
import script from "./BulkCuratedUpload.vue?vue&type=script&lang=ts&"
export * from "./BulkCuratedUpload.vue?vue&type=script&lang=ts&"
import style0 from "./BulkCuratedUpload.vue?vue&type=style&index=0&id=e55d8298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55d8298",
  null
  
)

export default component.exports